import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, Menu } from 'lucide-react';

import LogoImage from '../../../assets/images/Logo_blue_2x.svg';

export default function Header({ activeTab, onSelectMenuBar, menus }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    setOpenMenu(false);
  }, [location.pathname]);

  const goToPage = (path) => navigate(path);

  return (
    <header className="lo-header w-full px-5 sm:px-8 xl:px-12 py-3.5 flex items-center justify-between gap-4">
      <img
        src={LogoImage}
        alt="FlowexPay"
        className="h-11 w-auto object-contain cursor-pointer"
        onClick={() => onSelectMenuBar?.(0)}
      />

      <button
        type="button"
        aria-label="Abrir menú"
        onClick={() => setOpenMenu((prev) => !prev)}
        className="block xl:hidden p-2 rounded-xl hover:bg-[#E8F0FF] transition-colors"
      >
        <Menu className="w-7 h-7 text-[#092F7B]" />
      </button>

      {openMenu && (
        <div className="fixed inset-0 z-50 xl:hidden">
          <div
            className="absolute inset-0 bg-[#0B1B3A]/45 backdrop-blur-sm"
            onClick={() => setOpenMenu(false)}
          />
          <div className="absolute left-0 top-0 bottom-0 w-full sm:w-[22rem] bg-[#F4F7FC]/95 backdrop-blur-xl shadow-2xl px-6 py-5 border-r border-[#2A59C6]/10">
            <div className="h-full flex flex-col justify-between">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <img
                    src={LogoImage}
                    alt="FlowexPay"
                    className="h-11 w-auto object-contain"
                  />
                  <button type="button" onClick={() => setOpenMenu(false)} aria-label="Cerrar menú">
                    <X className="w-7 h-7 text-[#092F7B]" />
                  </button>
                </div>
                <ul className="space-y-1">
                  {menus.map((data, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        onSelectMenuBar(idx);
                        setOpenMenu(false);
                      }}
                      className={`w-full px-4 py-3 rounded-xl cursor-pointer flex items-center space-x-2 transition-colors ${
                        activeTab === idx
                          ? 'bg-[#E8F0FF] text-[#092F7B]'
                          : 'hover:bg-white/70 text-[#181D27]'
                      }`}
                    >
                      {data.icon('w-6 h-6 text-[#2A59C6]')}
                      <p className="w-full px-1 text-base font-semibold leading-5">
                        {data.title}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="space-y-2 pb-2">
                <button
                  type="button"
                  className="lo-btn-ghost-dark w-full px-6 py-2.5 rounded-xl font-semibold cursor-pointer"
                  onClick={() => goToPage('/login')}
                >
                  Iniciar sesión
                </button>
                <button
                  type="button"
                  className="lo-btn-primary w-full px-6 py-2.5 rounded-xl font-semibold cursor-pointer"
                  onClick={() => goToPage('/register')}
                >
                  Registrarse
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <nav className="lo-nav-pill hidden xl:flex items-center gap-1 rounded-full py-1.5 px-2">
        {menus.map((item, idx) => (
          <button
            key={idx}
            type="button"
            style={{ minWidth: item.minWidth }}
            className={`lo-nav-link px-4 py-2 rounded-full transition-all duration-200 text-sm cursor-pointer ${
              activeTab == idx ? 'lo-nav-link--on' : ''
            }`}
            onClick={() => onSelectMenuBar(idx)}
          >
            {item.title}
          </button>
        ))}
      </nav>

      <div className="hidden xl:flex space-x-2 text-sm font-semibold items-center">
        <button
          type="button"
          className="lo-btn-ghost-dark px-5 py-2.5 min-w-[9.5rem] rounded-xl cursor-pointer"
          onClick={() => goToPage('/login')}
        >
          Iniciar sesión
        </button>
        <button
          type="button"
          className="lo-btn-primary px-5 py-2.5 rounded-xl cursor-pointer"
          onClick={() => goToPage('/register')}
        >
          Registrarse
        </button>
      </div>
    </header>
  );
}
